import { render, staticRenderFns } from "./AddRootForm.vue?vue&type=template&id=6de21732&"
import script from "./AddRootForm.vue?vue&type=script&lang=js&"
export * from "./AddRootForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports